export const NPHIES_FEATURES = [
    'eligibility',
    'preauth-professional',
    'claim-professional',
    'preauth-institutional',
    'extension',
    'interim',
    'claim-institutional',
    'claim-lab',
    'preauth-pharmacy',
    'claim-pharmacy',
];
const FEATURES_BY_MODULE = {
    opd: ['eligibility', 'preauth-professional', 'claim-professional'],
    ipd: ['eligibility', 'preauth-institutional', 'extension', 'interim', 'claim-institutional'],
    lab: ['eligibility', 'claim-lab'],
    pharmacy: ['eligibility', 'preauth-pharmacy', 'claim-pharmacy'],
};
export function nphiesFeaturesOf(heldModules) {
    const held = new Set(heldModules);
    const features = new Set();
    if (!held.has('nphies'))
        return features;
    for (const [module, granted] of Object.entries(FEATURES_BY_MODULE)) {
        if (held.has(module))
            for (const feature of granted)
                features.add(feature);
    }
    return features;
}
export const PHARMACIST_SELECTION_REASONS = [
    'Generic',
    'patient-request',
    'innovative-noGeneric',
    'physician-approval',
    'physician-no-approval',
    'drug-pharmacyUnavailable',
    'drug-nationallyUnavailable',
    'Irreplaceable',
];
export const PHARMACIST_SELECTION_REASON_LABELS = {
    Generic: 'Generic dispensed',
    'patient-request': 'Patient asked for this brand',
    'innovative-noGeneric': 'Innovator drug with no generic',
    'physician-approval': 'Prescriber asked for it, with approval',
    'physician-no-approval': 'Prescriber asked for it, without approval',
    'drug-pharmacyUnavailable': 'Not available in this pharmacy',
    'drug-nationallyUnavailable': 'Not available in the country',
    Irreplaceable: 'SFDA irreplaceable drug',
};
//# sourceMappingURL=add-ons-nphies.js.map